export const INDEXABLE_ROUTE_GROUPS = Object.freeze([
  "/",
  "/uk",
  "/SelectExercise",
  "/uk/SelectExercise",
  "/SelectExercise/:muscleGroup",
  "/uk/SelectExercise/:muscleGroup",
]);

export const NON_INDEXABLE_ROUTE_GROUPS = Object.freeze([
  "/CreateExercise",
  "/uk/CreateExercise",
  "/LogExercise/:exerciseId",
  "/LogExercise/:exerciseId/:date",
  "/uk/LogExercise/:exerciseId",
  "/uk/LogExercise/:exerciseId/:date",
  "/sign-in",
  "/sign-in/*",
  "/sign-up",
  "/sign-up/*",
  "/sign-in/sso-callback",
  "/sign-up/sso-callback",
  "/uk/sign-in",
  "/uk/sign-in/*",
  "/uk/sign-up",
  "/uk/sign-up/*",
  "/uk/sign-in/sso-callback",
  "/uk/sign-up/sso-callback",
]);

function normalizeBasePath(path) {
  let raw = String(path || "").trim();
  if (raw.startsWith("/uk")) {
    raw = raw.slice(3);
  }
  if (!raw || raw === "/") {
    return "/";
  }

  return raw.startsWith("/") ? raw : `/${raw}`;
}

export function buildLocalizedAlternates(basePath) {
  const normalized = normalizeBasePath(basePath);
  const ukPath = normalized === "/" ? "/uk" : `/uk${normalized}`;

  return [
    { hrefLang: "en", path: normalized },
    { hrefLang: "uk", path: ukPath },
    { hrefLang: "x-default", path: normalized },
  ];
}

export function getPrerenderPublicPaths(muscleGroupIds = []) {
  const uniquePaths = new Set(["/", "/uk", "/SelectExercise", "/uk/SelectExercise"]);

  muscleGroupIds.forEach((id) => {
    if (!id) {
      return;
    }

    uniquePaths.add(`/SelectExercise/${id}`);
    uniquePaths.add(`/uk/SelectExercise/${id}`);
  });

  return Array.from(uniquePaths);
}
